import { AuthApis } from '@kinderlabs-pos/apis/storeinfo';
import { AxiosInstance } from 'axios';
import qs from 'qs';
import base64 from 'base-64';

export const setAxiosRequestTokenInterceptor = (axiosInstance: AxiosInstance) => {
	axiosInstance.interceptors.request.use((config) => {
		if (!config.headers) return config;

		let accessToken = localStorage.getItem('accessToken');
		const refreshToken = localStorage.getItem('refreshToken');
		const enterpriseHash = localStorage.getItem('enterpriseHash');

		if (!config.url?.includes('/auth') && accessToken) {
			//
			const isTokenExpiringSoon = isTokenExpiringSoonInAxios(accessToken);
			if (isTokenExpiringSoon) {
				AuthApis.reissueTokenAsync();
			}
		}

		accessToken = localStorage.getItem('accessToken');

		if (accessToken) config.headers['Authorization'] = `Bearer ${accessToken}`;
		if (refreshToken) config.headers['refreshToken'] = `Bearer ${refreshToken}`;
		config.headers['Enterprise-Hash'] = enterpriseHash || '';
		// ngrok 테스트 시, BE와 원활한 통신을 위함.
		config.headers['ngrok-skip-browser-warning'] = true;

		config.paramsSerializer = (params) => qs.stringify(params, { arrayFormat: 'repeat' });

		return config;
	});
};

function isTokenExpiringSoonInAxios(token: string) {
	const decodedToken = decodeToken(token);
	const currentTime = Math.floor(Date.now() / 1000); // 현재 시간 (초 단위)
	const oneMinuteLater = currentTime + 60; // 현재 시간에 60초 더함

	return decodedToken.exp < oneMinuteLater; // 만료 시간이 1분 이내인지 확인
}

function decodeToken(token: string) {
	const payload = token.substring(token.indexOf('.') + 1, token.lastIndexOf('.'));
	const decodingInfo = base64.decode(payload);
	return JSON.parse(decodingInfo);
}
